export default __webpack_public_path__ + "static/media/BCA27.b21fb763.jpg";